import {
  CashoutFunnelEventNames,
  CommonFunnelEventNames,
  DepositFunnelEventNames,
  Error,
  EventProps,
  UserEvent,
} from '../types/services';
import { TTrackerErrorContext } from './trackers/types';

import AmplitudeTracker from './trackers/amplitude';
import DatadogTracker from './trackers/datadog';
import FirebaseTracker from './trackers/firebase';
import KochavaTracker from './trackers/kochava';
import OptimilizeTracker from './trackers/optimizely';
import SingularTracker from './trackers/singular';

const ignoreErrorCall = (action: () => void) => {
  try {
    action();
  } catch (error) {
    console.error(error);
  }
};

export const trackUser = (user: UserEvent, newUser = false) => {
  ignoreErrorCall(() => {
    FirebaseTracker.trackUser(user, newUser);
    OptimilizeTracker.trackUser(user);
    KochavaTracker.trackUser(user);
    SingularTracker.trackUser(user);
    AmplitudeTracker.trackUser(user);
    DatadogTracker.trackUser(user);
  });
};

export const trackEvent = (eventName: string, props: EventProps = {}) => {
  ignoreErrorCall(() => {
    FirebaseTracker.trackEvent(eventName, props);
    OptimilizeTracker.trackEvent(eventName, props);
    if (
      process.env.REACT_APP_ENV === 'production' &&
      Object.values({
        ...CommonFunnelEventNames,
        ...DepositFunnelEventNames,
        ...CashoutFunnelEventNames,
      }).includes(eventName) &&
      window.gtag
    ) {
      window.gtag('event', eventName);
    }
  });
};

export const trackError = (error: unknown, context?: TTrackerErrorContext) => {
  ignoreErrorCall(() => {
    if (![400, 404, 412].includes((error as Error).status)) {
      DatadogTracker.trackError(error, context);
    }
  });
};

export const trackPageView = (page: string) => {
  ignoreErrorCall(() => {
    FirebaseTracker.trackPageView(page);
  });
};

export enum ErrorMessage {
  PRELOAD = 'Preloading failed',
  SEND_PHONE = 'Failed on send number',
  SEND_CODE = 'Failed on validate code',
  RESEND_CODE = 'Failed on resend code',
  ATTEMPT_DEPOSIT = 'Attempt deposit failed',
  ATTEMPT_DEPOSIT_CARD = 'Attempt card deposit failed',
  ATTEMPT_DEPOSIT_WALLET = 'Attempt wallet deposit failed',
  LOAD_METHODS = 'Load payment methods failed',
  IDENTITY_VALIDATION = 'Identity Validation Failed',
  REDIRECT_ERROR = 'Redirected because of merchant security',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mkError = (error: any, message: ErrorMessage) => {
  return { ...error, message };
};
